import React, { Component } from 'react'
import { Radio } from 'hljd'
import Table from '@common/Table'
import column from './column'
import styles from '../style.module.less'
import { observer, inject } from 'mobx-react'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

@inject('store')
@observer
export default class extends Component {
  render() {
    const { detailTab, changValue, tabArray, tab } = this.props.store
    return (
      <div className={styles.block}>
        <p className={styles.title}>{tabArray[tab]}详细数据</p>

        <RadioGroup value={detailTab} onChange={changValue('detailTab')}>
          <RadioButton value="1">昨日</RadioButton>
          <RadioButton value="7">近7日</RadioButton>
        </RadioGroup>

        <Table
          store={this.props.store}
          columns={column(tabArray, tab)}
          rowKey="id"
          style={{ marginTop: 20 }}
        />
      </div>
    )
  }
}
